export default __webpack_public_path__ + "af178d08b61f7ad7842b5e06477802bc.svg";